import { Plus } from "lucide-react";

/**
 * FAQ accordion. Uses native <details><summary> so keyboard/click/aria-expanded work out of the box.
 * Matches reference styling: bg-mist-off, gold '+' badge that rotates to 'x' when open.
 */
export default function FAQ({ section }) {
  const { eyebrow, heading, faqs = [] } = section;
  return (
    <section className="bg-white py-24 lg:py-32" data-testid="faq-section">
      <div className="container-mist">
        <div className="max-w-2xl text-left">
          {heading && (
            <h2 className="font-display text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.1] tracking-tight text-mist-navy">
              {heading}
            </h2>
          )}
          {(eyebrow || heading) && <div className="mt-4 gold-divider" />}
        </div>
        <div className="mt-12 max-w-4xl mx-auto space-y-4">
          {faqs.map((item, i) => (
            <details
              key={i}
              data-testid={`faq-${i}`}
              className="group bg-mist-off border border-mist-soft rounded-md p-6 open:border-mist-gold/50 transition"
            >
              <summary className="cursor-pointer list-none flex items-start justify-between gap-4">
                <span className="font-sans font-semibold text-lg text-mist-navy leading-snug tracking-tight">{item.question}</span>
                <span className="mt-1 h-6 w-6 shrink-0 rounded-full bg-mist-gold/15 border border-mist-gold/40 grid place-items-center text-mist-gold group-open:rotate-45 transition-transform">
                  <Plus className="h-3.5 w-3.5" aria-hidden />
                </span>
              </summary>
              {item.answer && (
                <div className="mt-4 space-y-3 text-sm text-mist-ink/75 leading-relaxed">
                  {item.answer.split("\n\n").map((p, k) => (
                    <p key={k}>{p}</p>
                  ))}
                </div>
              )}
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
